<template>
  <form action="" method="post">
    <h4 class="mbs">Email de Noticias y Anuncios</h4>
    <span>{{ email }}</span>
    <div class="row mtm">
      <div class="column small-12">
        <label>
          <input
            v-model="productOfferAndPromotion"
            type="checkbox"
            name="offersAndPromotions"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black"
              >Ofertas y promociones de producto</strong
            >
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          ¡Quiero recibir grandiosas ofertas personalizadas de DesignCrowd, cada mes!
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mtm">
          <input
            v-model="newsletter"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">Newsletter</strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.newsletterBlurb }}
        </p>
      </div>
    </div>
    <hr />
    <h4 class="mbm">Emails específicos de proyecto</h4>
    <div class="row">
      <div class="column small-12">
        <label>
          <input
            v-model="generalProjectAlert"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">
              Alertas y Notificaciones del Proyecto
            </strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.generalProjectAlertBlurb }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mtm">
          <input
            v-model="newDesignNotification"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">Nueva notificación de diseño</strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.newDesignNotificationBlurb }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mtm">
          <input
            v-model="dailySummary"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">Email de resumen diario</strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.dailySummaryBlurb }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mtm">
          <input
            v-model="inviteNotification"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">Notificación de Invitación</strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.inviteNotificationBlurb }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column text-center">
        <hr class="horizontal-rule horizontal-rule--form-frame-small mvm" />
        <button class="button mbn" @click="onSubmitUpdateSubscriptionsForm">
          Actualizar Preferencias
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      default: undefined,
    },
    productOfferAndPromotionEnabled: {
      type: Boolean,
      default: false,
    },
    newsletterEnabled: {
      type: Boolean,
      default: false,
    },
    generalProjectAlertEnabled: {
      type: Boolean,
      default: false,
    },
    newDesignNotificationEnabled: {
      type: Boolean,
      default: false,
    },
    dailySummaryEnabled: {
      type: Boolean,
      default: false,
    },
    inviteNotificationEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      productOfferAndPromotion: this.productOfferAndPromotionEnabled,
      newsletter: this.newsletterEnabled,
      generalProjectAlert: this.generalProjectAlertEnabled,
      newDesignNotification: this.newDesignNotificationEnabled,
      dailySummary: this.dailySummaryEnabled,
      inviteNotification: this.inviteNotificationEnabled,
      unPrettierNuggets: {
        newsletterBlurb: `Envíame un boletín informativo mensual personalizado con artículos de tecnología, negocios y diseño, actualizaciones del producto, tutoriales, perfiles y noticias de la comunidad.`,
        inviteNotificationBlurb: `Envíame una notificación cuando los diseñadores acepten / rechacen invitaciones`,
        generalProjectAlertBlurb: `Envíame emails relacionados con mis proyectos y concursos (como emails sobre pagos y estado de proyecto)`,
        newDesignNotificationBlurb: `Envíame una notificación cada vez que un diseño nuevo sea enviao a mi proyecto`,
        dailySummaryBlurb: `Envíame un resume diario de nuevos diseños y actividad asociada con mis proyectos abiertos`,
      }
    };
  },
  methods: {
    onSubmitUpdateSubscriptionsForm(e) {
      e.preventDefault();
      this.$emit('update-subscription', {
        productOfferAndPromotionEnabled: this.productOfferAndPromotion,
        newsletterEnabled: this.newsletter,
        generalProjectAlertEnabled: this.generalProjectAlert,
        newDesignNotificationEnabled: this.newDesignNotification,
        dailySummaryEnabled: this.dailySummary,
        inviteNotificationEnabled: this.inviteNotification,
      });
    },
  },
};
</script>
